export default __webpack_public_path__ + "static/media/Bracers of the Outer Dark.b9ec92c7.jpg";